<template>
    <div v-if="visible" class="pum-overlay" @click.self="close">
        <div class="pum-content">
            <button class="pum-close" aria-label="Close" @click="close">&times;</button>
            <h3>{{ title }}</h3>
            <p>{{ message }}</p>
            <div class="pum-actions">
                <button v-if="reason === 'paid_user'" class="pum-btn primary" @click="login">Log In</button>
                <button class="pum-btn secondary" @click="close">{{ secondaryLabel }}</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "PaidUserModal",
    props: {
        visible: { type: Boolean, default: false },
        email: { type: String, default: "" },
        reason: { type: String, default: "paid_user" },
        role: { type: String, default: "" }
    },
    computed: {
        title() {
            return this.reason === "wrong_role" ? "Access denied" : "Welcome back!";
        },
        message() {
            if (this.reason === "wrong_role") {
                const role = this.role || "this";
                return `Your account role (${role}) does not have permission to perform this action. Please log in with an authorized account.`;
            }
            return "It looks like you already started an order. Log in to complete your purchase and get started with your treatment.";
        },
        secondaryLabel() {
            return this.reason === "wrong_role" ? "Close" : "Not me — use a different email";
        }
    },
    methods: {
        close() {
            this.$emit("close");
        },
        login() {
            this.$router.push("/login?email=" + encodeURIComponent(this.email));
        }
    }
};
</script>

<style scoped>
.pum-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
}
.pum-content {
    position: relative;
    background: #fff;
    padding: 40px 28px 28px;
    border-radius: 16px;
    max-width: 400px;
    width: 90%;
    text-align: center;
    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.15);
}
.pum-close {
    position: absolute;
    top: 14px;
    right: 16px;
    background: transparent;
    border: none;
    font-size: 26px;
    line-height: 1;
    color: #333;
    cursor: pointer;
    padding: 4px 8px;
}
.pum-content h3 {
    margin: 0 0 14px;
    font-size: 22px;
    font-weight: 700;
    color: #111;
}
.pum-content p {
    margin: 0 0 24px;
    color: #555;
    font-size: 15px;
    line-height: 1.5;
}
.pum-actions {
    display: flex;
    flex-direction: column;
    gap: 10px;
}
.pum-btn {
    width: 100%;
    padding: 14px 20px;
    border-radius: 10px;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    transition: opacity 0.15s ease;
}
.pum-btn:hover {
    opacity: 0.9;
}
.pum-btn.primary {
    background: #e9ff86;
    color: #111;
    border: 1px solid #e9ff86;
}
.pum-btn.secondary {
    background: #fff;
    color: #111;
    border: 1px solid #d9d9d9;
}
</style>
